import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import styles from "./styles/gamePage.module.css"
import Navbar from "../component/navbar/Navbar"
import Banner from '../component/banner/Banner';
import "../component/gameshow/GameShow"
import bannerGame from "../assets/images/bannerGame.png"
import GameShow from '../component/gameshow/GameShow';
import Footer from '../component/footer/Footer';

const Games = () => {
  return (
    <>
      <div className='ewContainer'>
        <Navbar />
      </div>
      <div className={styles.content}>
        <Banner bannerImage={bannerGame} mouseImage={styles.non} />
      </div>
      <Container>
        <div style={{ position: 'relative' }}>
          <Row className={`d-flex justify-content-center ${styles['cardRow']}`} >
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/صخره-نوردی.jpg'
                title="صخره نوردی"
                text="وقت صخره نوردیه. توی هلیوم پارک 3 تا مسیر استاندارد برای اونایی که عاشق صخره نوردی هستن داریم. لازم نیست حرفه‌ای باشید، مربی‌های ما تجهیزات رو در اختیارتون می‌ذارن و راه و چاه بالا رفتن رو بهتون یاد می‌دن"
                video="https://s5.uupload.ir/files/mhvpcr/%DA%A9%D9%84%DB%8C%D9%BE%20%D9%87%D9%84%DB%8C%D9%88%D9%85/%D8%B5%D8%AE%D8%B1%D9%87%20%D9%86%D9%88%D8%B1%D8%AF%DB%8C-1.m4v"
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/صخره-نوردی.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/صخره-نوردی-(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/صخره-نوردی-(1).jpg'
                ]}
                modalIconText1 = "نوجوان،بزرگسال"
                modalIconText2 = "۱نفره "
                modalIconText3 = "بسته به لاین انتخابی "
                modalIconText4 = "طبقه ساحلی "
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D8%A8%D8%B3%DA%A9%D8%AA%D8%A8%D8%A7%D9%84-(2)(2).jpg'
                title="بسکتبال"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/بسکتبال-1.m4v"
                text = "می‌تونی از بازیکن‌های ان‌بی‌ای هم بلند‌تر بپری، چون کلی ترامپولین زیر پات هست. پرتاب توپ به حلقه وقتی در حال پرش هستی، خیلی چالشی و لذت بخشه. این‌جا برای کوچیک و بزرگ میدون رقابت‌های دوستانه و پر از خنده‌ است"
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بسکتبالا.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بسکتبال-(1)(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بسکتبال.jpg'
                ]}
                modalIconText1 = "نوجوان، بزرگسال "
                modalIconText2 = "۱ تا ۶نفر"
                modalIconText3 = "راحت "
                modalIconText4 = "طبقه جنگلی، طبقه ساحلی "
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بیلیارد.jpg'
                title="فوتیارد"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/بیلیارد-1.m4v"
                text = "سرگرم کننده و عالی برای خانواده‌ یا اکیپ‌های دوستانه. این بازی دقت و تمرکزت رو بالا می‌بره و لحظه‌های حساس و بامزه می‌سازه که می‌تونن بعدا به خاطره‌های شیرین تبدیل بشن."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بیلیارد.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بیلیارد.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بیلیارد.jpg'
                ]}
                modalIconText1 = "نوجوان، بزرگسال "
                modalIconText2 = "۲ نفره"
                modalIconText3 = "راحت"
                modalIconText4 = "طبقه جنگلی"
              />
            </Col>
          </Row>
        </div>
        <div style={{ position: 'relative' }}>
          <Row className={`d-flex justify-content-center ${styles['cardRow']}`} >
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D8%AA%D8%B1%D8%A7%D9%85%D9%BE%D9%88%D9%84%DB%8C%D9%86.jpg'
                title="ترامپولین"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/ترامپولین-1(1).m4v"
                text = "در هلیوم پارک فضای بزرگی به پریدن آزاد و بدون مانع روی ترامپولین اختصاص داده شده تا افراد در هر سنی، بتونن لذت پریدن و انجام حرکات نمایشی رو تجربه کنن. پرش روی ترامپولین یه فعالیت بدنی سالم و مفید به شمار میره."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین-(3).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین-2.jpg'
                ]}
                modalIconText1 = "کودک، نوجوان، بزرگسال"
                modalIconText2 = "نامحدود"
                modalIconText3 = "راحت"
                modalIconText4 = "طبقه جنگلی،طبقه ساحلی"
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین-حرفه-ای.jpg'
                title="ترامپولین حرفه ای"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/حرفه ای-1.m4v"
                text = "حرفه‌ای ها بیان جلو، اینجا می‌تونی راحت 3 متر بپری هوا، چون یه ترامپولین حرفه‌ای زیر پاته. با کمی تلاش و راهنمایی مربی‌هامون می‌تونید، لذت بلند پریدن و حرکات آکروباتیک رو روی این ترامپولین تجربه کنید."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین-حرفه-ای.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین-حرفه-ای.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین-حرفه-ای.jpg'
                ]}
                modalIconText1 = "نوجوان، بزرگسال"
                modalIconText2 = "۱نفره"
                modalIconText3 = "پرچالش"
                modalIconText4 = "طبقه ساحلی"
              
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/داج-بال-(3).jpg'
                title="داج بال"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/داج بال-1.m4v"
                text = "این وسط تنها با اون چیزی که توی بچگی تجربه می‌کردیم خیلی فرق داره. تشک‌ها و دیوارهای ترامپولین اینجا هستن تا این بازی نوستالژی رو با سرعت وهیجان بیشتر تجربه کنید."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/داج-بال-(1)(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/داج-بال-(3).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/داج-بال.jpg'
                ]}
                modalIconText1 = "نوجوان، بزرگسال"
                modalIconText2 = "۲تا۸ نفر"
                modalIconText3 = "معمولی"
                modalIconText4 = "طبقه جنگلی"
              />
            </Col>
          </Row>
        </div>
        <div style={{ position: 'relative' }}>
          <Row className={`d-flex justify-content-center ${styles['cardRow']}`} >
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D8%AF%DB%8C%D9%88%D8%A7%D8%B1-%D8%B4%DB%8C%D8%A8-%D8%AF%D8%A7%D8%B1-(1).jpg'
                title="دیوار شیب دار"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/Shib Darr-1.m4v"
                text = "فکر می‌کنی می‌تونی از دیوار راست بالا بری، پس این همون چالشیه که بهش نیاز داری. بچه‌ها هم عاشق این آیتم هستن، چون هم هیجان انگیزه هم توان جسمی‌شون رو زیاد می‌کنه."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/دیوار-شیب-دار-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/دیوار-شیب-دار-(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/دیوار-شیب-دار-(4).jpg'
                ]}
                modalIconText1 = "نوجوان، بزرگسال"
                modalIconText2 = "۱نفره"
                modalIconText3 = "معمولی"
                modalIconText4 = "طبقه جنگلی"

              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D8%B5%D8%AE%D8%B1%D9%87-%D9%86%D9%88%D8%B1%D8%AF%DB%8C-%DA%A9%D9%88%D8%AF%DA%A9%D8%A7%D9%86-(2).jpg'
                title="صخره نوردی کودکان"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/سخره کودک-1.m4v"
                text = "بچه‌تون دوست داره از دیوار راست بالا بره، پس لازمه بیاریدش هلیوم پارک. اینجا 4 تا مسیر اختصاصی برای صخره‌نوردی کودک داریم. زیر نظر مربی‌های حرفه‌ای با تهجیزات ایمنی، بچه‌ها می‌تونن لذت صعود و بالا رفتن رو تجربه کنن"
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/صخره-نوردی-کودکان-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/M.pslt0156.00_07_07_06.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/صخره-نوردی-کودکان-(2).jpg'
                ]}
                modalIconText1 = "کودک"
                modalIconText2 = "۱نفره"
                modalIconText3 = "بسته به لاین انتخابی"
                modalIconText4 = "طبقه ساحلی"

              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D9%81%D9%88%D8%AA%D8%A8%D8%A7%D9%84-%D8%AD%D8%A8%D8%A7%D8%A8%DB%8C-(4).jpg'
                title="فوتبال حبابی"
                video=" https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/حبابی-1.m4v"
                text = "توی این فوتبال تنه زدن قانونیه! چون یه حباب بزرگ تنت کردی. اگر دنبال یه بازی پر از خنده و شاد هستین، باید فوتبال حبابی رو تجربه کنید. زمین بازی از جنس تشک‌های نرم و فنریه تا بدون آسیب از زمین بازی بیرون بیاین."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/فوتبال-حبابی-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/فوتبال-حبابی-(3).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/فوتبال-حبابی.jpg'
                ]}
                modalIconText1 = "بزرگسال"
                modalIconText2 = "۲نفره"
                modalIconText3 = "معمولی"
                modalIconText4 = "طبقه ساحلی"
              />
            </Col>
          </Row>
        </div>
        <div style={{ position: 'relative' }}>
          <Row className={`d-flex justify-content-center ${styles['cardRow']}`} >
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%DA%A9%DB%8C%D8%AC-%D8%A8%D8%A7%D9%84-(2).jpg'
                title="کیج بال"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/کیج بال فاینال-1.m4v"
                text = "یه لحظه مکس کنی گل خوردی، توی این بازی باید همزمان به فکر حمله و دفاع باشی. کیج‌ بال سرعت عمل، تصمیم‌گیری و مهارت پرتاب رو به چالش می‌کشه. در این بازی کالری زیادی می‌سوزونی."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/کیج-بال-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/کیج-بال-(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/کیج-بال-(4).jpg'
                ]}
                modalIconText1 = "نوجوان،بزرگسال"
                modalIconText2 = "۲نفره"
                modalIconText3 = "معمولی"
                modalIconText4 = "طبقه جنگلی"
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D9%86%D8%A8%D8%B1%D8%AF-%DA%AF%D9%84%D8%A7%D8%AF%DB%8C%D8%A7%D8%AA%D9%88%D8%B1-(1).jpg'
                title="نبرد گلادیاتور"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/گلادیاتور-1.m4v"
                text = "کی می‌تونه بهتر تعادلش رو حفظ کنه؟ این بازی هم مفرح و جذابه، هم مهارت‌های جسمی‌تون رو بالا می‌بره. نبرد با بالش‌های بزرگ روی یه مسیر باریک، کم از نبردهای گلادیاتوری نداره :). زیر پاتون هم با بالش‌های اسفنجی ایمن شده."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/نبرد-گلادیاتور-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/نبرد-گلادیاتور-(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/نبرد-گلادیاتور.jpg'
                ]}
                modalIconText1 = "نوجوان،بزرگسال"
                modalIconText2 = "۲نفره"
                modalIconText3 = "معمولی"
                modalIconText4 = "طبقه ساحلی، طبقه جنگلی"
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D9%86%DB%8C%D9%86%D8%AC%D8%A7-%DA%A9%D9%88%D8%B1%D8%B3-(2).jpg'
                title="نینجا کورس"
                text = "این بازی یه آزمون واقعی برای سنجیدن آمادگی بدنیه. واقعا باید در حد یه نینجا چابک باشی تا بتونی هر چهار مرحله بازی رو پشت سر هم رد کنی. این چالش رو یک نفره یا گروهی انجام بدید تا ببینید کی از همه نینجاتره!"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/Ninja Final-1.m4v"
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/نینجا-کورس-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/نینجا-کورس-(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/نینجا-کورس-(3).jpg'
                ]}
                modalIconText1 = "نوجوان،بزرگسال"
                modalIconText2 = "۱تا ۳ نفر"
                modalIconText3 = "پرچالش"
                modalIconText4 = "طبقه ساحلی"
              />
            </Col>
          </Row>
        </div>
        <div style={{ position: 'relative' }}>
          <Row className={`d-flex justify-content-center ${styles['cardRow']}`} >
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D9%88%D8%A7%D9%84%DB%8C%D8%A8%D8%A7%D9%84.jpg'
                title="والیبال"
                text = "پریدن بالاتر از تور والیبال دیگه سخت نیست؛ وقتی یه ترامپولین زیر پات باشه. ترکیب توپ و تور والیبال با ترامپولین، یه ترکیب پر از نشاط و تحرکه. انجام این بازی به صورت اکیپی قطعا لذت بیشتری داره."
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/والیبال-1.m4v"
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/والیبال-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/والیبال-(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/والیبال-(3).jpg'
                ]}
                modalIconText1 = "نوجوان،بزرگسال"
                modalIconText2 = "۲تا۴ نفر"
                modalIconText3 = "معمولی"
                modalIconText4 = "طبقه ساحلی"
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D9%88%D8%A7%DB%8C%D9%BE-%D8%A7%D9%88%D8%AA-(2).jpg'
                title="وایپ اوت"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/وایپ-1.m4v"
                text="یه بازی گروهی و پر از افت و خیز. برنده اونیه که بهتر از بقیه بتونه از بازوهای چرخون جاخالی بده. توی این بازی لحظه‌های خنده دار و بامزه زیاد پیش میاد. ناگفته نمونه محدودیت قد و سن در این بازی وجود داره."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/وایپ-اوت-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/وایپ-اوت-(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/وایپ-اوت-(2).jpg'
                ]}
                modalIconText1 = "بزرگسال"
                modalIconText2 = "۱تا ۸ نفر"
                modalIconText3 = "بسته به سرعت"
                modalIconText4 = "طبقه ساحلی"
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D8%B3%D8%A7%D9%81%D8%AA-%D9%BE%D9%84%DB%8C-(1).jpg'
                title="سافت پلی"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/سافت پلی-1.m4v"
                text = "توی هلیوم پارک یه محوطه بازی اختصاصی برای کودکان داریم. جایی که بچه‌ها می‌تونن در کنار والدین‌شون حس خوب پریدن و بازی در محیط‌های جذاب و متفاوت از خونه رو تجربه کنن."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/سافت-پلی-(1).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/سافت-پلی-(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/سافت-پلی.jpg'
                ]}
                modalIconText1 = "کودک"
                modalIconText2 = "نامحدود"
                modalIconText3 = "راحت"
                modalIconText4 = "طبقه ساحلی،طبقه جنگلی"
              />
            </Col>
          </Row>
        </div>
        <div style={{ position: 'relative' }}>
          <Row className={`d-flex justify-content-center ${styles['cardRow']}`} >
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/%D8%A7%D8%B3%D8%AA%D8%AE%D8%B1-%D8%A7%D8%B3%D9%81%D9%86%D8%AC-(1)(2).jpg'
                title="استخر اسفنج"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/چاله اسفنج-1.m4v"
                text = "خیالت از فرود راحت باشه، چون هزارتا بالش اسفنجی منتظرن تا روشون پایین بیای. پس بلند بپر، پشتک بزن، اصلا خودت رو بنداز توی استخر و یه جنگ بالشی شروع کن. این‌جا آزادی برای پرش، بازی، جیغ و شادی."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/استخر-اسفنج-(1)(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/استخر-اسفنج(2).jpg',
                  'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/استخر-اسفنج-(1)(2).jpg'
                ]}
                modalIconText1 = "کودک،نوجوان،بزرگسال"
                modalIconText2 = "نامحدود"
                modalIconText3 = "راحت"
                modalIconText4 = "طبقه ساحلی،طبقه جنگلی"
              />
            </Col>
            <Col md={4}>
              <GameShow
                imgsrc='https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/M.pslt0156.00_12_47_17.jpg'
                title="تونل ماجراجویی"
                video="https://s5.uupload.ir/files/mhvpcr/کلیپ هلیوم/تونل-1.m4v "
                text = "افزایش مهارت‌های حرکتی، هیجان و بازی با بچه‌های هم سن و سال؛ این‌ها بخشی از جذاب‌های تونل ماجراجوییه. والدین هم می‌تونن از نزدیک شاهد بازی بچه‌ها در محیطی محافظت شده و ایمن باشن."
                images={[
                  'https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/M.pslt0156.00_12_47_17.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/M.pslt0156.00_12_47_17.jpg',
                  'https://s5.uupload.ir/files/mhvpcr/%D8%B9%DA%A9%D8%B3%20%D8%A8%D8%A7%D8%B2%DB%8C%20%D9%87%D9%84%DB%8C%D9%88%D9%85%20%D9%BE%D8%A7%D8%B1%DA%A9/M.pslt0156.00_12_47_17.jpg'
                ]}
                modalIconText1 = "کودک،نوجوان،بزرگسال"
                modalIconText2 = "نامحدود"
                modalIconText3 = "راحت"
                modalIconText4 = "طبقه ساحلی،طبقه جنگلی"
              />
            </Col>
          </Row>
        </div>
      </Container>
      <div>
        <Footer />
      </div>
    </>

  )
}
export default Games;